var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.location,"width":"100%","height":"350","frameborder":"0","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }